import request from 'app/utils/request';
import { getPresence } from 'app/utils/api';
import * as t from 'io-ts';
import { DateMarshallerType } from 'app/constants/schemas/Date';
import { decodeOrThrow } from 'app/utils/ioTs';
import { useGetServerTime } from '@engoo/react-server-time';
import { useMemoOne } from 'app/utils/useMemoOne';

const PresenceResponse = t.interface({
  data: t.interface({
    time: DateMarshallerType,
  }),
});

export const fetchTimeFromServer = async () => {
  const response = decodeOrThrow(PresenceResponse, await request(getPresence()));
  return response.data.time.valueOf();
};

export const useServerYear = () => {
  const getTime = useGetServerTime();
  const year = useMemoOne(() => {
    return getTime().getFullYear();
  }, [getTime]);

  return year;
};
